import axios from 'axios';

export class ClientGSSService {
    /**
     * Función que consulta al servicio en el back para obtener
     * la lista de todos los clientes.
     * @returns {Promise<unknown>} Lista con clientes.
     */
    getDataClientGSS() {
        return axios.get('/appapv/getDataClientGSS.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    /**
     * Función que realiza una petición al back para guardar un nuevo cliente
     * o editar un cliente seleccionado de la tabla.
     * @param idCliente Id del cliente seleccionado
     * @param clienteGSS Nombre del cliente seleccionado
     * @returns {Promise<unknown>} La tabla con todos los clientes
     */
    updateClientGSS(idCliente, clienteGSS) {
        return axios.post('/appapv/updateClientGSS.action', {}, {
            params: {
                idClienteGSS: idCliente,
                clienteGSS: encodeURIComponent((clienteGSS)),
            }
        }).then(res => {
            this.getDataClientGSS();
            return res.data;
        });
    }

    /**
     * Función que realiza una petición al back para eliminar
     * un cliente seleccionado de la tabla.
     * @param idCliente Id del cliente seleccionado
     * @param clienteGSS Nombre del cliente seleccionado
     * @returns {Promise<unknown>} La tabla con todos los clientes
     */
    deleteClientGSS(idCliente, clienteGSS) {
        return axios.delete('/appapv/deleteClientGSS.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idClienteGSS: idCliente,
                clienteGSS: clienteGSS,
            }
        }).then(res => this.getDataClientGSS());
    }
}